import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ItemProcessingSession } from "./item-processing";
import { ItemProcessingSource } from "./item-processing-source";

export const createItemProcessingSession = {
  name: "createItemProcessingSession" as const,
  input: z.object({
    source: ItemProcessingSource,
    locationId: locationIdFormat.schema,
    isGenericItem: z.boolean().optional(),
    workstationId: z.string().optional(),
    sourceReceivingBinId: storageLocationIdFormat.schema.nullish(),
  }),
  output: z.object({ session: ItemProcessingSession }),
};
